import { blackColors, whiteColor, successColor, warningColor } from 'assets/jss/material-dashboard-pro-react';

const accountDetailsSubpageStyle = (theme) => ({
	allUsers: {
		textAlign: 'right',
		marginRight: 8,
	},
	allUsersManagers: {
		margin: 'auto 0 auto auto',
	},
	avatarGridItem: {
		[theme.breakpoints.down('xs')]: {
			flexBasis: '51%',
			flexGrow: 1,
		},
		'& > div': {
			// card
			width: '112px',
			height: '112px',
			[theme.breakpoints.down('xs')]: {
				marginLeft: 'auto',
				marginRight: 'auto',
			},
			'& > div': {
				// card body
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				flexDirection: 'column',
				position: 'relative',
				height: '100%',
				"& input[type='file']": {
					display: 'none',
				},
				'& svg': {
					fontSize: '30px',
					color: '#a4a4a4',
				},
				'& button': {
					marginBottom: 0,
					marginTop: '10px',
				},
			},
		},
	},
	accountInfoGridItem: {
		flexGrow: 1,
		[theme.breakpoints.down('xs')]: {
			flexBasis: '51%',
		},
		'& > div': {
			// card
			minHeight: '112px',
			'& > div': {
				// card body
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				[theme.breakpoints.down('xs')]: {
					flexDirection: 'column',
					alignItems: 'flex-start',
				},
				'& > div': {
					'&:first-of-type': {
						[theme.breakpoints.down('xs')]: {
							marginBottom: '20px',
						},
					},
					'&:last-of-type': {
						minWidth: '200px',
						[theme.breakpoints.down('xs')]: {
							width: '100%',
						},
					},
				},
			},
		},
	},
	wrapper: {
		width: '100%',
	},
	accountInfoCaption: {
		marginBottom: '8px',
	},
	accountInfoHeader: {
		marginBottom: 0,
	},
	additionalInfo: {
		minHeight: '256px',
		'& > p:first-of-type': {
			marginBottom: '20px',
		},
		paddingBottom: 0,
	},
	additionalInfoButtonWrapper: {
		textAlign: 'right',
		marginTop: 'auto',
	},
	contactsCard: {
		height: 'calc(100% - 32px)',
		'& > div': {
			paddingBottom: '74px',
		},
	},
	contacts: {
		'& > div': {
			marginBottom: '6px',
		},
	},
	editSection: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		width: 'calc(100% - 40px)',
		margin: '0 20px',
		'& > div': {
			borderTop: `1px solid ${blackColors[6]}`,
			textAlign: 'right',
		},
		'& > p': {
			marginBottom: '8px',
		},
	},
	editButton: {
		top: '24px',
		bottom: 'auto',
	},
	deleteButton: {
		bottom: '16px',
	},
	avatarSet: {
		'& > div': {
			// card
			'& > div': {
				// card body
				paddingTop: '15px',
				'& button': {
					position: 'absolute',
					opacity: 0,
					transition: 'all .1s ease-in-out',
					marginTop: 0,
				},
				'& img': {
					transition: 'all .1s ease-in-out',
				},
				'&:hover': {
					'& img': {
						// opacity: '0.5',
					},
					'& button': {
						opacity: 1,
					},
				},
			},
		},
	},
	noManagersAdmins: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
		width: '100%',
		marginTop: '24px',
	},
	customDialogBody: {
		width: '288px',
		margin: '0 auto',
		maxWidth: '80%',
		marginTop: '24px',
		'& > div': {
			display: 'flex',
			alignItems: 'center',
			'& > span': {
				width: '-webkit-fill-available',
			},
		},
	},
	nextNumber: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	maxThreeNumbers: {
		textAlign: 'right',
		color: '#d41565',
	},
	error: {
		color: '#d41565 !important',
	},
	contactsCardHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		'& button': {
			marginTop: 0,
		},
		'& p': {
			marginTop: '9px',
		},
	},
	accountManagersCardBody: {
		position: 'relative',
	},
	singleAccountManagerWrapper: {
		marginTop: 24,
		marginBottom: 5,
		display: 'flex',
		'& > div': {
			'&:first-of-type': {
				'& svg': {
					color: whiteColor,
				},
			},
		},
	},
	managerNameWrapper: {
		marginBottom: 4,
	},
	accountTypeWrapper: {
		marginBottom: 8,
	},
	logoWrapper: {
		position: 'absolute',
		right: 16,
		top: 16,
		[theme.breakpoints.down('xs')]: {
			display: 'none',
		},
	},
	taxIdDescription: {
		color: warningColor[0],
		margin: '20px 0px',
	},
	taxDialogContainer: {
		padding: '20px 50px',
		maxWidth: '450px',
		margin: 'auto',
	},
	taxDialogInput: {
		width: '100%',
	},
	file: {
		paddingBottom: 16,
	},
	upload: {
		width: 'calc(100% - 42px)',
		display: 'inline-block',
		position: 'relative',
	},
	deleteIcon: {
		position: 'absolute',
		left: '100%',
	},
	success: {
		color: successColor[0],
		marginRight: 8,
	},
	fileNameContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	filename: {
		margin: 0,
		wordBreak: 'break-all',
	},
	successIcon: {
		width: 80,
		height: 80,
	},
	uploadItem: {
		display: 'flex',
		alignItems: 'center',
	},
	pdfIcon: {
		width: 30,
		height: 30,
		margin: 5,
	},
});

export default accountDetailsSubpageStyle;
